import { Button, Stack, Typography, useTheme } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { RestaurantTableIcon } from "@hugeicons/core-free-icons";
import { useAppDispatch } from "@/hooks";
import { setIsDineModeOpen } from "@/store/uiSlice";

const MissingDineModeBanner = () => {
    const { palette } = useTheme();
    const dispatch = useAppDispatch();

    const handleOpen = () => {
        dispatch(setIsDineModeOpen(true));
    };

    return (
        <Stack alignItems="center" spacing={1} pt={3} pb={1}>
            <HugeiconsIcon icon={RestaurantTableIcon} size={54} strokeWidth={1} color={palette.primary.main} />
            <Stack>
                <Typography textAlign="center">¿Cómo deseas disfrutar tu pedido hoy?</Typography>
            </Stack>
            <Stack direction="row" spacing={2} width="100%" justifyContent="center" sx={{ boxSizing: "border-box" }}>
                <Button onClick={handleOpen}>
                    Elegir
                </Button>
            </Stack>
        </Stack>
    );
};

export default MissingDineModeBanner;